import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import FloatingWhatsAppButton from "@/components/common/FloatingWhatsAppButton";
import FloatingCallButton from "@/components/common/FloatingCallButton";

export default function Layout() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return (
        <div className="min-h-screen flex flex-col bg-cream text-ink">
            <Navbar />
            <main className="flex-1 pt-20">
                <Outlet />
            </main>
            <FloatingWhatsAppButton />
            <FloatingCallButton />
            <Footer />
        </div>
    );
}
